import AsyncStorage from '@react-native-community/async-storage';


export function getUserToken() {
    const p = new Promise((resolve, reject) => {
        AsyncStorage.getItem('authKey', (err, res) => {
            if(err) return reject(err);
            if(res) {
                return resolve(res);
            }else{
                return reject('error')
            }
        })
    })

    return p;
}

// export default getUserToken;


 
